<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-ibase-cru-modal-content [showDefaultFormFooter]="false">
        <div class="file-details-container">
            <!-- File/Folder Name with Icon -->
            <div class="field">
                <label for="name" class="sr-only">File name</label>
                <div class="file-name-row">
                    <span [class]="getFileIcon()" class="file-icon"></span>
                    <input
                        id="name"
                        type="text"
                        pInputText
                        formControlName="name"
                        class="file-name-input"
                        [class.ng-invalid]="form.controls['name'].invalid && form.controls['name'].touched"
                        [class.ng-dirty]="form.controls['name'].dirty"
                    />
                </div>
                @if (form.controls['name'].invalid && form.controls['name'].touched) {
                    <small class="p-error">
                        @if (form.controls['name'].hasError('required')) {
                            File name is required.
                        }
                        @if (form.controls['name'].hasError('pattern')) {
                            Invalid file name. Only letters, numbers and these characters are allowed: _ . ! ( ) [ ] &#64; + = ; -
                        }
                    </small>
                }
            </div>

            <!-- Type -->
            <div class="field detail-row">
                <span class="detail-label">Type :</span>
                <span class="detail-value">{{ getFileType() }}</span>
            </div>

            <!-- Path -->
            <div class="field detail-row">
                <span class="detail-label">Path :</span>
                <span class="detail-value">{{ getHumanReadablePath() }}</span>
            </div>

            <!-- Size -->
            <div class="field detail-row">
                <span class="detail-label">Size :</span>
                <span class="detail-value">{{ fileEntry._formated_size || 'N/A' }}</span>
            </div>

            <!-- Created At -->
            <div class="field detail-row">
                <span class="detail-label">Created at :</span>
                <span class="detail-value">{{ fileEntry.created_at | date: 'medium' }}</span>
            </div>

            <!-- Created By -->
            <div class="field detail-row">
                <span class="detail-label">Created by :</span>
                <span class="detail-value">
                    <app-user-data-cell-display
                        displayType="table"
                        [rows]="[fileEntry]"
                        [row]="fileEntry"
                        attribute="created_by_uuid"
                        [value]="fileEntry.created_by_uuid"
                    />
                </span>
            </div>
        </div>

        <!-- Custom Footer -->
        <div class="modal-footer">
            <p-button label="Cancel" severity="secondary" (click)="onCancel()" type="button" />
            <p-button
                label="Apply"
                severity="primary"
                type="submit"
                [disabled]="!form.valid || showLoading || !hasNameChanged()"
                [loading]="showLoading"
            />
        </div>
    </app-ibase-cru-modal-content>
</form>

<style>
    .file-details-container {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        padding: 1rem 0;
    }

    .file-name-row {
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }

    .file-icon {
        font-size: 1.25rem;
        color: var(--primary-color);
    }

    .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border-width: 0;
    }

    .file-name-input {
        flex: 1;
        font-weight: 500;
        cursor: text;
        pointer-events: auto;
        background-color: var(--surface-ground);
        border: 1px solid var(--surface-border);
        padding: 0.5rem;
        border-radius: 4px;
    }

    .file-name-input:focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem var(--primary-color-alpha-20);
        border-color: var(--primary-color);
    }

    .file-name-input:hover {
        border-color: var(--primary-color);
    }

    .detail-row {
        display: flex;
        gap: 0.5rem;
    }

    .detail-label {
        font-weight: 600;
        min-width: 120px;
        color: var(--text-color-secondary);
    }

    .detail-value {
        flex: 1;
        color: var(--text-color);
    }

    .text-muted {
        color: var(--text-color-secondary);
        font-style: italic;
    }

    .modal-footer {
        display: flex;
        justify-content: flex-end;
        gap: 0.5rem;
        padding-top: 1rem;
        border-top: 1px solid var(--surface-border);
        margin-top: 1rem;
    }
</style>
